import { useTheme } from "@/utils/theme-context";
import { doc, updateDoc } from "firebase/firestore";
import { useLocation, useNavigate } from "react-router-dom";
import { db } from "@/firebase/firebaseConfig";

import EditModuleLessons from "./EditModuleLessons";
import Button from "../UI/Button";

const EditModule = () => {
  const location = useLocation();

  const { moduleId, category, isVisible, title } = location.state || {};

  const navigate = useNavigate();
  const collectionMap = {
    Amazon: "amazonLessons",
    Dropshipping: "dsLessons",
    amzBonus: "amzBonusLessons",
    dsBonus: "dsBonusLessons",
    Trial: "trialLessons",
    Invest: "amazonInvestLessons",
    Development: "developmentLessons",
  };

  const currentCollection = collectionMap[category] || "amazonLessons";

  const { theme } = useTheme();

  const handleUpdateModule = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const updatedTitle = formData.get("title");

    const updatedIsVisible = formData.get("isVisible") === "on";

    try {
      const docRef = doc(db, currentCollection, moduleId);
      await updateDoc(docRef, {
        title: updatedTitle,
        isVisible: updatedIsVisible,
      });

      alert("Модуль успешно обновлён!");
    } catch (error) {
      console.error("Ошибка при обновлении модуля:", error);
      alert("Не удалось обновить модуль. Попробуйте снова.");
    }
  };

  return (
    <div className="layout layout--admin">
      <form onSubmit={handleUpdateModule} className="accountInfo-body ">
        <p className="layout__title">Редактировать модуль</p>
        <div className="accountInfo-body-item">
          <label htmlFor="title">Название модуля</label>
          <input
            name="title"
            required
            defaultValue={title}
            className={`input input--${theme}`}
          />
        </div>
        <div className="accountInfo-body-item">
          <label htmlFor="category">Категория</label>

          <input
            className={`input input--${theme} input--disabled`}
            name="category"
            required
            defaultValue={category}
            disabled
          ></input>
        </div>

        <div className="accountInfo-body-item">
          <label htmlFor="isVisible">
            <input
              name="isVisible"
              type="checkbox"
              defaultChecked={isVisible}
            />
            Показывать модуль
          </label>
        </div>
        <Button title="Обновить модуль" color="blue" submit={"submit"} />
        {/* <Button
          title="Удалить модуль"
          color="red"
          onClick={() => null}
        ></Button> */}
      </form>

      <br />

      <div className="editModule-button">
        <p className="layout__title">Видеоуроки</p>
        <Button
          title="Добавить новый видеоурок в модуль"
          color="red"
          onClick={() =>
            navigate(`/edit-module/lesson/:id`, {
              state: {
                currentCollection: currentCollection,
                id: moduleId,
              },
            })
          }
        />
      </div>

      <EditModuleLessons
        moduleId={moduleId}
        currentCollection={currentCollection}
      />
    </div>
  );
};

export default EditModule;
